import {
  Building2, Paintbrush, Home, Droplets, FileSearch, Layers, ShowerHead, Zap, Flame,
  Cable, ShieldCheck, Hammer, ClipboardCheck, ClipboardList, CircleDollarSign,
  BarChart3, Handshake,
} from "lucide-react";

export const SERVICES = [
  { icon: Building2, title: "Recuperação de Fachadas", desc: "Recuperação, restauração, tratamento e valorização estética e estrutural." },
  { icon: Paintbrush, title: "Pintura e Textura", desc: "Pintura predial, aplicação de textura e revitalização de fachadas." },
  { icon: Home, title: "Telhados e Coberturas", desc: "Inspeção, manutenção, recuperação e soluções para coberturas." },
  { icon: Droplets, title: "Impermeabilização", desc: "Soluções para prevenção e tratamento de infiltrações e umidade." },
  { icon: FileSearch, title: "Patologias Construtivas", desc: "Diagnóstico técnico e identificação das causas dos problemas." },
  { icon: Layers, title: "Recuperação Estrutural", desc: "Soluções técnicas para recuperação e conservação de elementos construtivos." },
  { icon: ShowerHead, title: "Sistemas Hidráulicos", desc: "Manutenção, adequações e modernização." },
  { icon: Zap, title: "Sistemas Elétricos", desc: "Manutenção, adequações e modernização de instalações." },
  { icon: Flame, title: "PPCI", desc: "Soluções e adequações relacionadas à segurança contra incêndio." },
  { icon: Cable, title: "Trabalho em Altura", desc: "Serviços especializados com acesso por cordas, rapel e técnicas adequadas de segurança." },
  { icon: ShieldCheck, title: "Linha de Vida e Segurança", desc: "Instalação e adequação de sistemas de segurança para trabalhos em altura." },
  { icon: Hammer, title: "Reformas e Áreas Comuns", desc: "Modernização, revitalização e recuperação de áreas comuns." },
  { icon: ClipboardCheck, title: "Fiscalização de Obras", desc: "Acompanhamento técnico, controle de execução e qualidade." },
  { icon: ClipboardList, title: "Vistorias e Inspeções", desc: "Avaliações técnicas, registros fotográficos e identificação de necessidades." },
  { icon: CircleDollarSign, title: "Análise de Orçamentos", desc: "Avaliação técnica de propostas e apoio na tomada de decisão." },
  { icon: BarChart3, title: "Planejamento de Manutenção", desc: "Definição de prioridades, planejamento de investimentos e ações preventivas." },
  { icon: Handshake, title: "Consultoria para Síndicos", desc: "Suporte técnico para decisões mais seguras e investimentos mais assertivos." },
];

export const DIFFERENTIATORS = [
  { title: "EVITE GASTOS DESNECESSÁRIOS", desc: "Avaliação técnica antes de investir." },
  { title: "PROTEJA SEU PATRIMÔNIO", desc: "Soluções pensadas para preservar e valorizar a edificação." },
  { title: "REDUZA RISCOS", desc: "Identificação de problemas antes que se transformem em grandes prejuízos." },
  { title: "TENHA APOIO TÉCNICO", desc: "O síndico não precisa tomar decisões técnicas sozinho." },
  { title: "MAIS TRANSPARÊNCIA", desc: "Relatórios, registros, acompanhamento e documentação." },
  { title: "MAIS SEGURANÇA", desc: "Engenharia aplicada à gestão do condomínio." },
];

export const PLANS = [
  {
    name: "PLANO ESSENCIAL",
    price: "R$ 597",
    period: "/mês",
    tagline: "Para condomínios que querem começar a se proteger.",
    features: [
      "1 visita técnica mensal",
      "Relatório fotográfico",
      "Registro das patologias",
      "Canal direto com engenheiro",
      "Orientação para manutenções",
      "Histórico técnico do condomínio",
    ],
    highlighted: false,
  },
  {
    name: "PLANO GESTÃO",
    price: "R$ 1.497",
    period: "/mês",
    tagline: "Tudo do Essencial + engenharia nas suas decisões.",
    features: [
      "Tudo do Essencial +",
      "Validação de orçamentos",
      "Análise técnica de propostas",
      "Priorização de investimentos",
      "Planejamento anual",
      "Apoio ao síndico nas decisões",
      "Reunião técnica trimestral",
    ],
    highlighted: true,
    badge: "MAIS ESCOLHIDO",
  },
  {
    name: "PLANO BLINDADO",
    price: "R$ 3.997",
    period: "/mês",
    tagline: "Tudo do Gestão + fiscalização completa da obra.",
    features: [
      "Tudo do Gestão +",
      "Fiscalização de obras",
      "Controle de qualidade",
      "Auditoria de execução",
      "Relatórios técnicos completos",
      "Acompanhamento de fornecedores",
      "Certificação da solução executada",
    ],
    highlighted: false,
  },
];

export const STEPS = [
  { step: "01", name: "DIAGNÓSTICO", desc: "Entendemos a realidade do condomínio." },
  { step: "02", name: "PLANEJAMENTO", desc: "Definimos prioridades e melhores soluções." },
  { step: "03", name: "EXECUÇÃO", desc: "Colocamos o planejamento em prática." },
  { step: "04", name: "FISCALIZAÇÃO", desc: "Acompanhamos a qualidade da execução." },
  { step: "05", name: "VALIDAÇÃO", desc: "Verificamos se a solução foi corretamente executada." },
  { step: "06", name: "REGISTRO", desc: "Criamos histórico técnico para o condomínio." },
];

export const PROJECTS = [
  {
    id: "anita-garibaldi",
    name: "Residencial Anita Garibaldi",
    location: "Porto Alegre/RS",
    category: "FACHADAS",
    service: "Recuperação e pintura de fachada",
    description:
      "Recuperação completa da fachada do residencial. Serviços executados: lavagem com hidrojateamento e aplicação de hipoclorito de sódio, recomposição de áreas desagregadas, aplicação de tela estruturante e pintura geral de acabamento.",
    cover: "/images/projects/anita-capa.jpg",
    before: "/images/projects/anita-antes.jpg",
    during: null,
    after: "/images/projects/anita-depois.jpg",
    result: "Fachada recuperada, estruturada e valorizada — patrimônio protegido.",
  },
  {
    id: "intercity",
    name: "Restauração de Fachada — Hotel Intercity Cidade Baixa",
    location: "Porto Alegre/RS",
    category: "FACHADAS",
    service: "Restauração de fachada e pintura predial",
    description:
      "Projeto de restauração da fachada do Hotel Intercity Cidade Baixa. Um trabalho que uniu técnica, planejamento, segurança e qualidade, transformando a aparência da edificação e contribuindo para a valorização, conservação e proteção do patrimônio.",
    cover: "/images/projects/intercity-capa.jpg",
    before: "/images/projects/intercity-antes.jpg",
    during: null,
    after: "/images/projects/intercity-depois.jpg",
    result:
      "Uma fachada revitalizada, moderna e preparada para continuar fazendo parte da paisagem de Porto Alegre.",
  },
  {
    id: "sesc-gravatai",
    name: "Reforma e Revitalização — Área Interna / Poço de Luz / SESC",
    location: "Gravataí/RS",
    category: "OBRAS ESPECIAIS",
    service: "Reforma e recuperação de área interna",
    description:
      "Recuperação total do espaço interno e do poço de luz, com planejamento, execução e acompanhamento técnico de ponta a ponta para devolver funcionalidade, segurança e conforto ao ambiente.",
    cover: "/images/projects/sesc-capa.jpg",
    before: "/images/projects/sesc-antes.jpg",
    during: null,
    after: "/images/projects/sesc-depois.jpg",
    result: "Espaço interno recuperado e revitalizado em sua totalidade.",
  },
  {
    id: "escola-liberato",
    name: "Projeto de Revitalização — Escola Liberato Salzano",
    location: "Porto Alegre/RS",
    category: "REFORMAS",
    service: "Revitalização de espaços escolares",
    description:
      "Revitalização dos espaços da Escola Liberato Salzano. Um trabalho desenvolvido com planejamento, técnica, segurança e atenção aos detalhes, contribuindo para a recuperação e valorização dos espaços da instituição — um ambiente mais conservado, funcional, seguro e agradável para toda a comunidade escolar.",
    cover: "/images/projects/liberato-capa.jpg",
    before: null,
    during: "/images/projects/liberato-obra.jpg",
    result: "Ambientes renovados, seguros e prontos para a comunidade escolar.",
  },
  {
    id: "santa-casa-7o-andar",
    name: "Criação do 7º Andar — Hospital Santa Casa",
    location: "Porto Alegre/RS",
    category: "OBRAS ESPECIAIS",
    service: "Estrutura metálica e criação de novo pavimento",
    description:
      "Criação do 7º pavimento do Hospital Santa Casa com estrutura metálica leve sobre a edificação existente. Obra executada com trabalho em altura e acesso por cordas, com planejamento e acompanhamento técnico da Realiza Engenharia.",
    cover: "/images/projects/santacasa-capa.jpg",
    before: null,
    during: "/images/projects/santacasa-durante.jpg",
    after: null,
    result: "Novo pavimento criado sobre a estrutura existente — hospital ampliado com segurança técnica.",
  },
  {
    id: "rodoviaria-porto-alegre",
    name: "Reforma da Rodoviária de Porto Alegre",
    location: "Porto Alegre/RS",
    category: "REFORMAS",
    service: "Recuperação e limpeza técnica de lajes, vigas e vigotas",
    description:
      "Primeira etapa da reforma da Rodoviária de Porto Alegre concluída com sucesso: recuperação e limpeza técnica das lajes, vigas e vigotas do terminal, com hidrojateamento, plataformas elevatórias e equipe especializada, com acompanhamento técnico da Realiza Engenharia.",
    cover: "/images/projects/rodoviaria-capa.jpg",
    before: null,
    during: null,
    after: null,
    gallery: [
      "/images/projects/rodoviaria-g1.jpg",
      "/images/projects/rodoviaria-g2.jpg",
      "/images/projects/rodoviaria-g3.jpg",
      "/images/projects/rodoviaria-g4.jpg",
    ],
    result: "Primeira etapa concluída com sucesso — estrutura recuperada e terminal renovado com técnica e segurança.",
  },
  {
    id: "estacionamento-piso",
    name: "Recuperação de Pintura do Piso — Estacionamento",
    location: "Porto Alegre/RS",
    category: "OBRAS ESPECIAIS",
    service: "Pintura e demarcação de piso",
    description:
      "Recuperação e pintura do piso do estacionamento com aplicação de epóxi e demarcação completa de vagas e circulação — acabamento uniforme, resistente e durável.",
    cover: "/images/projects/estacionamento-capa.jpg",
    before: null,
    during: null,
    after: null,
    gallery: [
      "/images/projects/estacionamento-g1.jpg",
      "/images/projects/estacionamento-g2.jpg",
    ],
    result: "Piso recuperado e demarcado — estacionamento com cara de novo.",
  },
  {
    id: "fachada-edificio-residencial",
    name: "Recuperação de Fachada — Edifício Residencial",
    location: "Porto Alegre/RS",
    category: "FACHADAS",
    service: "Recuperação e pintura de fachada",
    description:
      "Recuperação completa da fachada de edifício residencial: tratamento das superfícies degradadas, pintura e acabamento — transformação visual, proteção da edificação e valorização do patrimônio.",
    cover: "/images/projects/fachada-edificio-capa.jpg",
    before: "/images/projects/fachada-edificio-antes.jpg",
    during: null,
    after: "/images/projects/fachada-edificio-depois.jpg",
    result: "Fachada repaginada com visual moderno — arraste o comparativo e veja a transformação.",
  },
];

export const CASES = [
  {
    name: "Residencial Anita Garibaldi",
    location: "Porto Alegre/RS",
    image: "/images/projects/anita-depois.jpg",
    challenge: "Fachada degradada, com áreas desagregadas e desplacamento visível.",
    solution:
      "Hidrojateamento, recomposição com tela estruturante e pintura geral de acabamento.",
    result: "Fachada recuperada e patrimônio valorizado.",
  },
  {
    name: "Hotel Intercity Cidade Baixa",
    location: "Porto Alegre/RS",
    image: "/images/projects/intercity-depois.jpg",
    challenge:
      "Restaurar a fachada de um hotel em plena operação, sem impactar hóspedes.",
    solution:
      "Restauração técnica com trabalho em altura, planejamento e controle de qualidade.",
    result: "Fachada revitalizada e novo padrão de excelência para o patrimônio.",
  },
  {
    name: "SESC Gravataí — Poço de Luz",
    location: "Gravataí/RS",
    image: "/images/projects/sesc-depois.jpg",
    challenge:
      "Área interna e poço de luz severamente degradados, exigindo recuperação completa.",
    solution:
      "Reforma e revitalização integral com acompanhamento técnico de ponta a ponta.",
    result: "Espaço interno totalmente recuperado e funcional.",
  },
];

export const FAQ = [
  {
    q: "Por que contratar uma empresa de engenharia para manutenção predial?",
    a: "Porque a manutenção feita sem critério técnico custa mais e dura menos. Uma empresa de engenharia diagnostica as causas reais dos problemas, especifica as soluções corretas e acompanha a execução — evitando gastos desnecessários, retrabalhos e riscos para os moradores.",
  },
  {
    q: "Quando uma fachada precisa de recuperação?",
    a: "Sinais como desplacamento de pintura, manchas de umidade, trincas, fissuras e estruturas desagregadas indicam que a fachada precisa de avaliação técnica. Quanto mais cedo o diagnóstico, menor o custo e o risco da intervenção.",
  },
  {
    q: "Qual a importância da manutenção preventiva?",
    a: "A manutenção preventiva antecipa problemas antes que se tornem obras emergenciais caras. Ela preserva o valor do imóvel, garante a segurança dos moradores e permite o planejamento de investimentos ao longo do ano — sem surpresas no caixa do condomínio.",
  },
  {
    q: "Como funciona o Plano Condomínio Seguro Realiza?",
    a: "O plano leva engenharia contínua à gestão do seu condomínio: visitas técnicas periódicas, relatórios fotográficos, registro das patologias, validação de orçamentos e apoio técnico ao síndico nas decisões. Existem três níveis — Essencial, Gestão e Blindado — conforme a necessidade de cada edificação.",
  },
  {
    q: "A Realiza atende condomínios?",
    a: "Sim. Os condomínios são nossa especialidade: atuamos na manutenção predial, recuperação de fachadas, áreas comuns, vistorias e na gestão técnica que apoia síndicos e conselhos nas decisões.",
  },
  {
    q: "A Realiza realiza trabalho em altura?",
    a: "Sim, com equipes especializadas em acesso por cordas, rapel e técnicas adequadas de segurança, seguindo as normas aplicáveis — incluindo instalação e adequação de linhas de vida.",
  },
  {
    q: "A Realiza fiscaliza obras de terceiros?",
    a: "Sim. Atuamos como engenharia independente no acompanhamento técnico, controle de execução e auditoria de qualidade de obras realizadas por terceiros, garantindo que o que foi contratado seja efetivamente entregue.",
  },
  {
    q: "É possível solicitar orçamento pelo site?",
    a: "Sim. Preencha o formulário de orçamento aqui do site e sua solicitação chega diretamente à nossa equipe pelo WhatsApp. Você também pode chamar no (51) 98177-9245.",
  },
  {
    q: "Como funciona a avaliação técnica?",
    a: "Um engenheiro visita o condomínio, inspeciona as áreas, registra as condições por fotos e laudo, identifica as patologias e suas causas e apresenta as recomendações priorizadas — a base para decisões seguras e investimentos inteligentes.",
  },
  {
    q: "A Realiza atende administradoras?",
    a: "Sim. Somos a engenharia parceira de administradoras de condomínios, atuando em carteiras de edifícios com vistorias, planejamento de manutenção, análise de orçamentos e obras.",
  },
];

export const AUDIENCES = [
  { title: "SÍNDICOS", quote: "Tenha respaldo técnico para suas decisões." },
  { title: "ADMINISTRADORAS", quote: "Conte com uma engenharia parceira para seus condomínios." },
  { title: "CONDOMÍNIOS", quote: "Proteja seu patrimônio antes que o problema fique maior." },
  { title: "EMPRESAS", quote: "Planejamento, manutenção e engenharia para sua operação." },
];

export const SERVICE_OPTIONS = [
  "Fachada", "Pintura", "Textura", "Telhado", "Impermeabilização", "Infiltração",
  "Hidráulica", "Elétrica", "PPCI", "Trabalho em altura", "Linha de vida",
  "Reforma", "Área comum", "Fiscalização", "Vistoria", "Gestão condominial", "Outro",
];
